import { useLocation, useSearchParams } from 'react-router-dom'

import { getApartmentNavSearchParams } from './apartmentNav'

export {
  buildApartmentNavHref,
  isApartmentListPath,
  isApartmentMapPath,
  isApartmentViewPath,
  matchApartmentNavTarget,
  resolveApartmentNavHref
} from './apartmentNav'
export function getLivabilityBasePath(pathname: string): string {
  if (pathname.startsWith('/admin')) return '/admin'
  if (pathname.startsWith('/user')) return '/user'
  return ''
}

function pathWithSearch(basePath: string, search: URLSearchParams): string {
  const query = search.toString()
  return query ? `${basePath}?${query}` : basePath
}

export function useLivabilityPaths() {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const base = getLivabilityBasePath(pathname)

  const listSearch = getApartmentNavSearchParams('list', searchParams, pathname)
  const mapSearch = getApartmentNavSearchParams('map', searchParams, pathname)

  return {
    search: `${base}/apartments-search`,
    list: pathWithSearch(`${base}/apartments`, listSearch),
    map: pathWithSearch(`${base}/apartments-map`, mapSearch),
    detail: (id: number) => `${base}/apartments/${id}`,
    mapWithIds: (ids: number[]) => {
      const params = getApartmentNavSearchParams('map', searchParams, pathname)
      params.set('ids', ids.join(','))
      params.set('from', 'chat')
      return pathWithSearch(`${base}/apartments-map`, params)
    }
  }
}

export function useIsLivabilityRoute(): boolean {
  const { pathname } = useLocation()
  return (
    pathname.includes('/apartments-search') ||
    pathname.includes('/apartments-map') ||
    /\/apartments(\/\d+)?$/.test(pathname)
  )
}

export function useIsMapRoute(): boolean {
  const { pathname } = useLocation()
  return pathname.includes('/apartments-map')
}
